module.exports = __webpack_public_path__ + "img/对号.e33fa4c4.svg";